import React, {Component} from 'react'
import { connect } from 'react-redux'
import { Form, Field } from 'react-final-form'
import EnquiryActionCreators from 'redux-modules/enquiry/EnquiryActionCreators'

const required = value => (value ? undefined : 'Required')

const InputField =({ input, meta ,...rest}) => (
    <div style={{fontSize: '0.8rem'}}>
        <label>{rest.label}</label>
        <input className='form-control mb-3' {...input} type="text" placeholder={rest.placeholder} />
        {meta.error && meta.touched && <span style={{color: '#ff3fc5'}}>{meta.error}</span>}
    </div>
)

const TextAreaField =({ input, meta ,...rest}) => (
    <div style={{fontSize: '0.8rem'}}>
        <label>{rest.label}</label>
        <textarea className='form-control mb-3' style={{height: '160px'}} {...input} type="text" placeholder={rest.placeholder} />
        {meta.error && meta.touched && <span style={{color: '#ff3fc5'}}>{meta.error}</span>}
    </div>
)

class ApplyForm extends Component {

  constructor(props) {
      super(props)
      this.state = {
        enquirySubmitted: false
      };
  }


  onSubmit=(values) =>{
    console.log("values", values)
    return this.props.postEnquiry('enquiry1',{
        "subject":"Career Application Owlgo",
        "data":values
    })
  }

  render () {
    return (
      <div style={{maxWidth: '400px', margin: 'auto'}}>
        <Form
            onSubmit={this.onSubmit}

            render={({ handleSubmit, pristine, invalid, reset }) => (
                <form onSubmit={
                    event => {
                        const promise = handleSubmit(event);
                        promise.then(() => {
                            reset()
                            this.setState({enquirySubmitted: true})
                        });
                        return promise;
                        }
                    } style={{margin: 'auto'}}>
                    <div className='mb-4'>
                        <Field name="name" component={InputField} label={"Name"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="email" component={InputField} label={"Email"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="contactNumber" component={InputField} label={"Contact Number"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="address" component={InputField} label={"Address"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="postalCode" component={InputField} label={"Postal Code"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="country" component={InputField} label={"Country"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="jobPosition" component={InputField} label={"Job Position of Interest (if applicable)"} validate={required} />
                    </div>
                    <div className='mb-4'>
                        <Field name="additionalDetails" component={TextAreaField} label={"Additional Details"} placeholder={"Additional Details (Add a cover letter or anything else you want to share), max 300 characters"} validate={required} />
                    </div>

                    <button className='btn btn-primary d-flex align-items-center mb-4' type="submit" disabled={ pristine || invalid}>
                        <span className='pr-5'>Submit</span> 
                        <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                    </button>
                    {
                        this.state.enquirySubmitted ? <div style={{letterSpacing: '0.1rem', color: '#33aa49'}}>Your enquiry has been submitted!</div> : null
                    }
                    
                </form>
            )}
        />
      </div>
    )
  }

}

const mapStateToProps = ( state, props ) => ({
})

const mapDispatchToProps ={
    postEnquiry: EnquiryActionCreators.postEnquiry
    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplyForm)



// WEBPACK FOOTER //
// ./src/components/careers/ApplyForm.js